<template>
  <div class="recommendGoodsMain" v-loading.fullscreen.lock="loading">
    <!--为你推荐 -->
    <nav>
      <h4>
        {{ $t("message.recommend") }}
        <!-- 同步到首页 -->
        <el-button type="primary" class="fr" @click="hotGoodsToClient" v-if="isAuth(397)">{{
          $t("message.SyncHome")
        }}</el-button>
      </h4>
    </nav>
    <!-- 分类 -->
    <div class="classification">
      <div class="item" v-for="(item, index) in tableData" :key="index" :class="{ choose: index == i }"
        @click="getClassification(item, index)">
        {{ item.translate_name }}
      </div>
    </div>

    <div>
      <el-carousel trigger="click" ref="shopCarousel" :interval="3000" :autoplay="autoplay"
        @mouseover.native="autoplay = false" @mouseleave.native="autoplay = true">
        <el-carousel-item v-for="(item, index) in goodsList" :key="index" v-show="item.status">
          {{ item }}
          <div class="recommendGoodsBox">
            <div v-for="goodsItem in item" :key="goodsItem.goods_id" class="recommendGoods">
              <div class="imageBox">
                <el-image :src="goodsItem.goods_pic">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                  <div slot="placeholder">
                    <i class="el-icon-loading"></i>
                  </div>
                </el-image>
              </div>
              <div class="goodsTitle" :title="goodsItem.goods_title">
                {{ goodsItem.goods_title }}
              </div>
              <div class="priceBox">
                <span class="priceBox">
                  {{ goodsItem.goods_price }}{{ $t("message.unit") }}（{{
                    (goodsItem.goods_price * $store.state.rate).toFixed(0)
                  }}{{ $t("message.Yen") }}）
                </span>
              </div>
              <!-- 过期 -->
              <div class="overdue" v-if="goodsItem.goods_status_name == '已下架'">
                <img src="@/assets/icon/overdue .png" alt="">
              </div>
              <!-- 操作 -->
              <div class="operation">
                <!-- 更改 -->
                <el-button size="mini" type="danger" @click="showEdit(goodsItem)" v-if="isAuth(395)">
                  {{ $t("message.change") }}</el-button>
                <!-- 删除 -->
                <el-button size="mini" type="danger" class="dark" @click="hotGoodsDelete(goodsItem.id)"
                  v-if="isAuth(396)">
                  {{ $t("message.delete") }}</el-button>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 修改商品 -->
    <el-dialog :title="$t('message.modifyGoods')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="650px" center>
      <div class="editGoods">
        <div class="items">
          <!--  商品原图  -->
          <div class="goodsTitle">
            {{ $t("message.originalGoods") }}
          </div>
          <img :src="item.goods_pic" alt="" />
        </div>
        <div class="icon">
          <img src="@/assets/icon/replace.png" alt="" />
        </div>
        <div class="items">
          <div class="goodsTitle">
            <!--    图片预览 -->
            {{ $t("message.previewPicture") }}
            <el-upload class="upload-demo" drag :action="uploadUrl" :show-file-list="false"
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <div class="el-upload__text">
                <i class="el-icon-upload"></i><em>{{ $t("message.uoloadPic") }}</em>
              </div>
            </el-upload>
          </div>
          <img :src="item.edit_pic" alt="" />
        </div>
        <div class="items">
          <div class="goodsTitle">
            <!--商品原名称-->
            {{ $t("message.originalNameCommodity") }}
          </div>
          <el-input type="textarea" v-model="item.goods_title" resize="none" show-word-limit readonly>
          </el-input>
        </div>
        <div class="icon">
          <img src="@/assets/icon/replace.png" alt="" />
        </div>
        <div class="items">
          <div class="goodsTitle">
            <!-- 译文修正 -->
            {{ $t("message.translationCorrect") }}
          </div>
          <el-input type="textarea" v-model="item.edit_title" resize="none" show-word-limit onfocus="this.select()">
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <el-button type="primary" @click="edit">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { changeArr } from "@/utlis/utlis";
export default {
  data() {
    return {
      i: 0,
      tableData: [],
      goodsList: [],
      autoplay: true,
      dialogVisible: false,
      item: {},
      uploadUrl: "https://jpapi.rakumart.cn/api/common/uploadFile",
      loading: false,
    };
  },
  components: {},
  computed: {},
  created() {
    this.getPersonalizedGoods();
  },
  methods: {
    // 获取推荐商品数据
    getPersonalizedGoods() {
      this.$api.siteConfiguration.hotGoodsGet().then((res) => {
        this.tableData = res.data;
        this.goodsList = res.data[0].home_goods;
        this.ProcessingShopData();
      });
    },
    //获取商品分类
    getClassification(item, i) {
      this.i = i;
      this.goodsList = item.home_goods;
      this.ProcessingShopData();
    },
    // 数据处理
    ProcessingShopData() {
      //console.log(23);
      if (this.goodsList.length < 6) return false
      let lack = 6 - (this.goodsList.length % 6); //取得店铺商品数离6个的倍数差多少个商品的数量
      //console.log("缺多少个商品", lack);
      //差多少个就从最前面取多少个填充到最后
      for (let i = 0; i < lack; i++) {
        this.goodsList.push(this.goodsList[i]);
      }
      //  分成六个一组
      this.goodsList = changeArr(this.goodsList, 6);
      //console.log(this.goodsList);
      this.$forceUpdate();
    },
    // 滑动店铺商品列表
    shopCarouselChange(type) {
      if (type == "left") {
        this.$refs.shopCarousel.prev();
      } else if (type == "right") {
        this.$refs.shopCarousel.next();
      }
    },
    // 显示修改
    showEdit(item) {
      item.edit_pic = "";
      item.edit_title = "";
      let data = JSON.stringify(item);
      this.item = JSON.parse(data);
      this.dialogVisible = true;
    },
    //添加修改图片
    handleAvatarSuccess(file) {
      if (file.code != 0) return this.$message.error(file.msg);
      this.loading = false;
      this.$message.success(file.msg);
      this.item.edit_pic = file.data;
      this.$forceUpdate();
    },
    //修改
    edit() {
      this.$confirm(
        this.$t("message.homePreviewAffirm"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.save"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          // 修改推荐商品
          let datas = {
            goods_id: this.item.id,
            goods_title: this.item.edit_title
              ? this.item.edit_title
              : this.item.goods_title,
            goods_pic: this.item.edit_pic
              ? this.item.edit_pic
              : this.item.goods_pic,
          };
          this.$api.siteConfiguration.hotGoodsSave(datas).then((res) => {
            this.$message.success(res.msg);
            this.getPersonalizedGoods();
            this.dialogVisible = false;
          });
        })
        .catch(() => { });
    },
    //删除
    hotGoodsDelete(goods_id) {
      this.$confirm("删除之后会补充一个新的商品", this.$t("message.prompt"), {
        confirmButtonText: this.$t("message.cancel"),
        cancelButtonText: this.$t("message.ok"),
        cancelButtonClass: 'primary',
        confirmButtonClass: 'dark',
        type: "warning",
        center: true,
      })
        .then(() => {

        })
        .catch(() => {
          // 修改推荐商品
          this.$api.siteConfiguration
            .hotGoodsDelete({ goods_id })
            .then((res) => {
              this.$message.success(res.msg);
              this.getPersonalizedGoods();
              this.dialogVisible = false;
            });
        });
    },
    //同步到首页
    hotGoodsToClient() {
      this.$confirm(
        " 确认之后将会把商品原首页数据进行替换，是否确认",
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.cancel"),
          cancelButtonText: this.$t("message.ok"),
          cancelButtonClass: 'primary',
          confirmButtonClass: 'dark',
          type: "warning",
          type: "warning",
          center: true,
        }
      )
        .then(() => {

        })
        .catch(() => {
          // 修改推荐商品
          this.$api.siteConfiguration.hotGoodsToClient().then((res) => {
            this.$message.success(res.msg);
          });
        });
    },
    // 图片格式
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      this.loading = true;
      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG和PNG 格式!");
        this.loading = false;
      }
      return isJPG || isPNG;
    },
  },
};
</script>
<style lang='scss' scoped>
@import "@/css/mixin.scss";

.recommendGoodsMain {
  width: $pageWidth;
  margin: 0px auto 80px;

  nav {
    height: 40px;

    align-items: center;
    margin-bottom: 10px;

    h4 {
      line-height: 40px;
      color: black;
      font-size: 21px;
      font-weight: 600;
    }
  }

  .recommendGoodsBox {
    display: flex;

    .recommendGoods {
      cursor: pointer;
      width: 210px;
      padding: 10px;
      height: 290px;
      background-color: white;
      border: #e8e8e8 solid 1px;
      border-radius: 6px;
      margin: 14px;
      transition: 0.3s;
      position: relative;

      .imageBox {
        width: 100%;
        height: 187.31px;
        margin-bottom: 5px;
        text-align: center;
        background-color: white;

        /deep/ .el-image {
          $imgSize: 181.31px;
          width: $imgSize;
          height: $imgSize;
          transition: 0.3s;
          text-align: center;

          i {
            font-size: $imgSize/4;
            line-height: $imgSize;
          }
        }
      }

      .goodsTitle {
        height: 39px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1.5;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-bottom: 5px;
        color: #404040;
        font-family: "Open Sans", Sans-serif;
        font-size: 13px;
        font-weight: 500;
      }

      .priceBox {
        color: #b4272b;
        font-size: 15px;
        font-weight: 500;
        line-height: 1.6em;
      }

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 0px 15px rgb(223, 223, 223);

        .operation {
          display: block;
        }
      }

      .overdue {
        position: absolute;
        top: 5px;
        right: 5px;

        img {
          width: 40px;
        }
      }

      .operation {
        position: absolute;
        right: 5px;
        bottom: 30px;
        display: none;
      }
    }

    .recommendGoods:first-child {
      margin-left: 0;
    }

    .recommendGoods:last-child {
      margin-right: 0;
    }
  }

  .lookMore {
    padding: 22px 34px;
    text-align: right;
    color: #1a289d;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;

    i {
      font-weight: 800;
      font-size: 14px;
    }
  }
}

/deep/ .el-carousel__arrow--right,
/deep/ .el-carousel__arrow--left {
  display: none;
  width: 100px;
  height: 100px;
  background: #ffffff;
  opacity: 0.6;
  border-radius: 50%;
}

/deep/ .el-carousel__arrow {
  background: rgba(255, 255, 255, 0.5);

  i {
    color: $homePageSubjectColor;
    font-size: 60px;
    font-weight: 700;
  }
}

/deep/ .el-carousel__button {
  display: none;
  width: 12px;
  height: 12px;
  background: #ffffff;
  border-radius: 50%;
}

/deep/ .el-carousel__indicator.el-carousel__indicator--horizontal.is-active .el-carousel__button {
  outline: 3px solid $homePageSubjectColor;
  background-color: transparent;
}

.notHaveData {
  $imgSize: 181.31px;
  width: $imgSize;
  height: $imgSize;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    font-size: $imgSize/4;
  }
}

.classification {
  overflow: hidden;

  .item {
    float: left;
    padding: 10px 20px;
    background-color: transparent;
    border-radius: 4px;
    margin-right: 20px;
    cursor: pointer;
  }

  .choose {
    background-color: #b4272b;
    color: #fff;
  }
}

.editGoods {
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px;

  .items {
    width: 240px;
    margin: 0 0 10px 0;

    .goodsTitle {
      height: 48px;
      line-height: 48px;
      margin-bottom: 15px;
      width: 240px;
      position: relative;

      /deep/ .el-upload {
        width: 160px;
        height: 50px;
        position: absolute;
        top: 0;
        right: 0;
      }

      /deep/.el-upload-dragger {
        background-color: #fff9ef;
        width: 160px;
        height: 50px;
        border-color: #ffa200;

        .el-upload__text {
          width: 160px;
          height: 50px;

          .el-icon-upload {
            margin: 0;
            font-size: 25px;
            vertical-align: middle;
            margin-right: 10px;
            color: #ffa200;
          }

          em {
            color: #ffa200;
          }
        }
      }
    }

    img {
      height: 240px;
      width: 240px;
    }
  }

  .icon {
    width: 80px;
    text-align: center;
    padding-top: 183px;

    img {
      width: 25px;
      transform: rotate(180deg);
    }
  }

  /deep/ .el-textarea__inner {
    height: 240px;

    &:focus {
      background-color: #f2f8fb;
    }
  }
}
</style>